import * as types from './profile.actionTypes';

const initState = {
  profile: null,
  isFollowing: false,
  isFetchingProfile: false,
  lastActive: null,
};

const profileReducer = (state = initState, action) => {
  switch (action.type) {
    case types.FETCH_PROFILE_REQUEST:
      return {
        ...state,
        profile: null,
        isFetchingProfile: true,
      };
    case types.FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.profile.user,
        isFollowing: action.profile.following,
        lastActive: action.profile.last_active,
        isFetchingProfile: false,
      };
    case types.FETCH_PROFILE_FAILURE:
      return {
        ...state,
        isFetchingProfile: false,
      };
    case types.FOLLOW_PROFILE_SUCCESS:
      return {
        ...state,
        isFollowing: action.profile.following,
      };
    default:
      return state;
  }
};

export default profileReducer;
